import { render } from "./TabletFormView.vue?vue&type=template&id=60f88ed7"
import script from "./TabletFormView.vue?vue&type=script&lang=js"
export * from "./TabletFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__